import memoize from 'memoize-one';
import React from 'react';

const Columns = memoize((/* clickHandler = () => {} */) => [
  {
    name: 'Rut y Nombre',
    cell: item => (
      <div className="d-flex flex-column" role="presentation" aria-hidden="true">
        <span className="text-muted" data-tag="allowRowEvents">
          {item?.nationalIdentification}
        </span>
        <span className="text-truncate" data-tag="allowRowEvents">
          {item?.fullName}
        </span>
      </div>
    ),
    sortable: false
  },
  {
    name: 'Cargo',
    cell: item => item?.jobTitle?.name || item.jobTitle,
    sortable: false
  },
  {
    name: 'Fecha de Ingreso',
    selector: 'startDate',
    sortable: false
  }
]);

export default Columns;
